export const buSlugParam = "buSlug";
export const personalSlugParam = "personalSlug";
export const dateParam = "date";

export const routePaths = {
  root: {
    root: "/",
    pBuSlug: {
      root: `/:${buSlugParam}`,
      dashboard: { root: `/:${buSlugParam}/dashboard` },
      assignedAccount: {
        root: `/:${buSlugParam}/assigned-account`,
        staff: { root: `/:${buSlugParam}/assigned-account/staff` },
        client: { root: `/:${buSlugParam}/assigned-account/client` },
        corporation: { root: `/:${buSlugParam}/assigned-account/corporation` },
        candidateDetail: {
          root: `/:${buSlugParam}/assigned-account/:${personalSlugParam}`,
          aiJobSuggestion: {
            root: `/:${buSlugParam}/assigned-account/:${personalSlugParam}/ai-job-suggestion`,
          },
          manualJobSuggestion: {
            root: `/:${buSlugParam}/assigned-account/:${personalSlugParam}/manual-job-suggestion`,
          },
        },
      },
      recruitment: {
        root: `/:${buSlugParam}/recruitment`,
        companyMatchingList: {
          root: `/:${buSlugParam}/recruitment/company-matching-list`,
        },
        staffMatchingList: {
          root: `/:${buSlugParam}/recruitment/staff-matching-list`,
        },
      },
      eodReport: {
        root: `/:${buSlugParam}/eod-report`,
        todaysReport: {
          root: `/:${buSlugParam}/eod-report/todays`,
          tickets: { root: `/:${buSlugParam}/eod-report/todays/tickets` },
          reporting: {
            root: `/:${buSlugParam}/eod-report/todays/reporting-line`,
          },
        },
        eodHistory: {
          root: `/:${buSlugParam}/eod-report/history`,
          report: {
            root: `/:${buSlugParam}/eod-report/history/:${dateParam}`,
            tickets: {
              root: `/:${buSlugParam}/eod-report/history/:${dateParam}/tickets`,
            },
            reporting: {
              root: `/:${buSlugParam}/eod-report/history/:${dateParam}/reporting-line`,
            },
          },
        },
      },
      pendingReport: {
        root: `/:${buSlugParam}/pending-report`,
        tickets: {
          root: `/:${buSlugParam}/pending-report/tickets`,
        },
        reporting: {
          root: `/:${buSlugParam}/pending-report/reporting-line`,
        },
      },
      manageTask: {
        root: `/:${buSlugParam}/manage-task`,
        kanbanView: { root: `/:${buSlugParam}/manage-task/kanban` },
        listView: {
          operator: { root: `/:${buSlugParam}/manage-task/list/operator` },
          sales: { root: `/:${buSlugParam}/manage-task/list/sales` },
          customerSuccess: {
            root: `/:${buSlugParam}/manage-task/list/customer-success`,
          },
          corporation: {
            root: `/:${buSlugParam}/manage-task/list/corporation`,
          },
          staff: { root: `/:${buSlugParam}/manage-task/list/staff` },
          root: `/:${buSlugParam}/manage-task/list`,
        },
      },
      members: { root: `/:${buSlugParam}/members` },
    },
  },
};
